var t = /* @__PURE__ */ ((r) => (r.light = "white", r.dark = "#24272c", r))(t || {});
export {
  t as ThemeColor
};
